import React, { useEffect, useState, useRef } from "react";

// --- ASSETS --- //
import mockup_1 from "../../assets/mockup-1.png";
import mockup_2 from "../../assets/mockup-2.png";
import mockup_3 from "../../assets/mockup-3.png";
import background_1 from "../../assets/bkgd-img-1.png";

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import UpdateIcon from '@mui/icons-material/Update';
import VerifiedIcon from '@mui/icons-material/Verified';

import BusinessIcon from '@mui/icons-material/Business';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';

// --- CSS --- //
import "../../styles/home.css";

// --- COMPONENTS --- //
import GoogleMapComponent from "../../components/GoogleMap";
import CertificationCard from "../../components/Cards/CertificationCard";
import { getGymList, getGymLocationData } from "../../utilities/firestore/firestoreUtils";

const Home = () => {
    const [gymData, setGymData] = useState([]); // State to hold gym data with location data
    const [openIndex, setOpenIndex] = useState(null);

    const [currentPosition, setCurrentPosition] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const intervalRef = useRef(null);
    const containerRef = useRef(null);
    const cardWidth = useRef(0);


    useEffect(() => {
        const fetchGyms = async () => {
            const gymList = await getGymList();
            const gymData = await getGymLocationData(gymList);
            setGymData(gymData);
        };

        fetchGyms();
    }, []);

    const toggleAnswer = (index) => {
        if (openIndex === index) {
            setOpenIndex(null); // Close if already open
        } else {
            setOpenIndex(index); // Open the clicked question
        }
    };

    useEffect(() => {
        // Dynamically calculate the width of a single card
        if (containerRef.current) {
            cardWidth.current = containerRef.current.firstChild.offsetWidth;
        }

        startCarousel();

        return () => stopCarousel(); // Cleanup on unmount
    }, []);

    const moveCarousel = () => {
        if (!isPaused) {
            setCurrentPosition((prev) => {
                const nextPosition = prev - cardWidth.current;
                const maxScroll = -cardWidth.current * (containerRef.current.children.length - 1);

                return nextPosition <= maxScroll ? 0 : nextPosition;
            });
        }
    };

    const startCarousel = () => {
        stopCarousel(); // Prevent duplicate intervals
        intervalRef.current = setInterval(moveCarousel, 3000);
    };

    const stopCarousel = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    const handleMouseDown = () => {
        setIsPaused(true);
        stopCarousel();
    };

    const handleMouseUpOrLeave = () => {
        setIsPaused(false);
        startCarousel();
    };

    return (
        <div className="home-container">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content">
                    <h1>Welcome to VERT CERT</h1>
                    <p>Your ultimate indoor rock climbing certification platform. Track, manage, and achieve your climbing goals with speed, safety, and ease. Join our waitlist today to show climbing gyms that our community is excited for this revolutionary app!</p>
                    <a href="/waitlist">
                        <button className="cta-button">Join Waitlist Today</button>
                    </a>
                </div>
                <div className="hero-image">
                    <img src={mockup_3} alt="App Mockup" />
                </div>
                <div className="hero-scroll-down">
                    <KeyboardArrowDownIcon style={{ fontSize: "30pt" }} />
                </div>
            </section>

            {/* Features Section */}
            <section className="features">
                <h2>Features</h2>
                <div className="features-grid">
                    <div className="feature-item">
                        <img src={mockup_1} alt="Feature 1" />
                        <h3>Track Progress</h3>
                        <p>Track and manage your climbing certifications, instantly accessible at any participating gym nationwide.</p>
                    </div>
                    <div className="feature-item" id="feature-middle-item">
                        <img src={mockup_2} alt="Feature 2" />
                        <h3>Connect with Gyms</h3>
                        <p>Effortlessly connect with participating climbing gyms nationwide and explore them using our interactive map.</p>
                    </div>
                    <div className="feature-item">
                        <img src={mockup_3} alt="Feature 3" />
                        <h3>Stay Certified</h3>
                        <p>Stay on top of your certifications—get notified when it’s time to renew.</p>
                    </div>
                </div>
            </section>

            {/* What Certifications are Offered Section */}
            <section className="certs-offered-section">
                <div className="certs-offered-section-hero-container">
                    <div className="certs-offered-section-hero-container-left">
                        <h2>What Certifications? These Certifications.</h2>
                        <p>
                        Our climbing certifications adhere to national standards set by organizations like the AMGA, CWA, and others, ensuring that users gain essential knowledge, skills, and techniques recognized across the industry. These certifications promote safety, confidence, and progression in the climbing environment while meeting the rigorous benchmarks established by leading experts.
                        </p>
                    </div>
                    <div className="certs-offered-section-hero-container-right">
                        <CertificationCard
                            key={1}
                            certTitle={"My Certification"}
                            certGym={"VERT CERT LLC"}
                            certEmployee={"John Smith"}
                            startDate={"Mon, Jan 01, 2024"}
                            endDate={"Mon, Jan 01, 2025"}
                            startTime={"09:00 AM"}
                            endTime={"11:59 PM"}
                            certType={"Example"}
                            dateDifference={"Valid"}
                        />
                    </div>
                </div>

                {/* Carousel */}
                <div
                    className="carousel"
                    onMouseDown={handleMouseDown}
                    onMouseUp={handleMouseUpOrLeave}
                    onMouseLeave={handleMouseUpOrLeave}
                >
                    <div
                        className="carousel-container"
                        ref={containerRef}
                        style={{
                            display: "flex",
                            transform: `translateX(${currentPosition}px)`,
                            transition: isPaused ? "none" : "transform 0.3s ease-in-out",
                        }}
                    >
                        {/* Add Certification Cards Here */}
                        {[
                            {
                                title: "Bouldering 101",
                                description: "This certification is designed for beginner climbers to introduce them to the fundamentals of bouldering. Learn basic techniques, safety, and how to climb with confidence.",
                            },
                            {
                                title: "Top Rope Belay (PBUS)",
                                description: "This certification teaches the proper belaying technique using the PBUS method, ensuring climber safety and the correct use of belay devices.",
                            },
                            {
                                title: "Top Rope Belay (ATC)",
                                description: "Focus on mastering belay techniques with the ATC device, essential for safe climbing practices in top rope climbing scenarios.",
                            },
                            {
                                title: "Top Rope Belay (GriGri)",
                                description: "This certification covers belaying with the GriGri device, focusing on proper technique, safety, and device handling for top rope climbing.",
                            },
                            {
                                title: "Lead Belay (PBUS)",
                                description: "Learn how to belay climbers on a lead rope using the PBUS technique, a vital skill for lead climbing and maintaining safety in more dynamic situations.",
                            },
                            {
                                title: "Lead Belay (ATC)",
                                description: "This certification covers lead belaying using the ATC device, with an emphasis on technique, safety, and how to manage lead climbing risks effectively.",
                            },
                            {
                                title: "Lead Belay (GriGri)",
                                description: "Focus on belaying lead climbers with the GriGri device. This certification teaches specific techniques to keep climbers safe during lead climbing.",
                            },
                        ].map((cert, index) => (
                            <div key={index} className="cert-info-card-container">
                                <div>
                                    <div className="cert-info-card-header-section">
                                        <div className="cert-info-card-header">
                                            <h2>{cert.title}</h2>
                                            <p>Valid for one year</p>
                                        </div>
                                        <VerifiedIcon />
                                    </div>
                                    <div className="cert-info-card-body">
                                        <h4>Description:</h4>
                                        <p>{cert.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section >

            {/* How It Works Section */}
            < section className="how-it-works" >
                <object className="background-graphic" aria-label="Background graphic representing VERT CERT experience"></object>
                <h2>How It Works</h2>
                <div className="how-it-works-content">
                    <div className="how-it-works-steps">
                        <div className="step">
                            <h3 className="step-number">1.</h3>
                            <div className="step-content" id="step-content-first-content" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                <div style={{ marginRight: "20px" }}>
                                    <h3>Create Your Profile</h3>
                                    <p>Sign up and create your VERT CERT profile to get started on your climbing journey today.</p>
                                </div>
                                <a href="/sign-up"><button className="cta-button" id="step-content-first-content-button">Sign Up Now</button></a>
                            </div>
                        </div>
                        <div className="step">
                            <h3 className="step-number">2.</h3>
                            <div className="step-content">
                                <h3>Visit a Nearby Participating Gym</h3>
                                <p>Take a certification test at a participating gym and get certified upon successful completion of the test.</p>
                            </div>
                        </div>
                        <div className="step">
                            <h3 className="step-number">3.</h3>
                            <div className="step-content">
                                <h3>Start Climbing</h3>
                                <p>With your new certification, climb at any participating VERT CERT gym nationwide with which you are authorized.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            {/* Map Section */}
            < section id="home-map-container" >
                <div id="home-map-subcontainer">
                    <div className="map-header">
                        <h2>Explore Participating Gyms Nationwide</h2>
                        <p>Join our waitlist and help us expand the VERT CERT network by adding more gyms to our map. Be part of shaping the future of nationally recognized climbing certifications!</p>
                        <a href="/waitlist"><button className="cta-button">Join Waitlist</button></a>
                    </div>
                    <GoogleMapComponent
                        gymData={gymData}
                        zoom={4}
                        useUserLocation={false}
                        mapHeight="500px"
                        borderRadius="0px 10px 10px 0px" //Initial for web (Changes in GoogleMapComponent)
                    />
                </div>
                <div className="map-footer">
                    <h4>Don't see your local gym?</h4>
                    <p>Reach out to us, we love partnering with our community and making everyone's lives easier and safer.</p>
                    <a href="/contact"><button className="contact-us-button">Contact Us</button></a>
                </div>
            </section >

            {/* New Benefits Section */}
            < section className="benefits-container" >
                <object className="benefit-background-graphic" aria-label="Background graphic representing VERT CERT experience"></object>
                <h2>Why Choose VERT CERT?</h2>
                <div className="benefit-subcontainer">
                    <div className="benefit-item" id="benefit-climber">
                        <div className="benefit-header">
                            <h3>For Climbers</h3>
                            <EmojiPeopleIcon style={{ fontSize: "30pt" }} />
                        </div>
                        <ul className="benefit-list">
                            <li><span className="icon"><CheckCircleIcon /></span><p>Track and manage your certifications with ease.</p></li>
                            <li><span className="icon"><LocationOnIcon /></span><p>Find nearby participating gyms using our interactive map.</p></li>
                            <li><span className="icon"><DashboardIcon /></span><p>Personalized dashboard to view your progress and certifications.</p></li>
                            <li><span className="icon"><PersonIcon /></span><p>Easily manage your profile and certifications online.</p></li>
                        </ul>
                        <div className="benefit-actions">
                            <a href="/climbers"><button className="benefit-button" id="benefit-button-learn-more">Learn More</button></a>
                            <a href="/sign-up"><button className="benefit-button" id="benefit-action-button">Sign Up</button></a>
                        </div>
                    </div>
                    <div className="benefit-item" id="benefit-gym">
                        <div className="benefit-header">
                            <h3>For Gyms</h3>
                            <BusinessIcon style={{ fontSize: "30pt" }} />
                        </div>
                        <ul className="benefit-list">
                            <li><span className="icon"><SettingsIcon /></span><p>Manage authorized employees easily through the gym portal.</p></li>
                            <li><span className="icon"><VerifiedUserIcon /></span><p>Quickly verify certifications with a unique VERT CERT ID</p></li>
                            <li><span className="icon"><PhoneAndroidIcon /></span><p>Access the certification platform on both web and iOS for easy accessibility.</p></li>
                            <li><span className="icon"><UpdateIcon /></span><p>More features will be added to streamline your certification process.</p></li>
                        </ul>
                        <div className="benefit-actions">
                            <a href="/gyms"><button className="benefit-button" id="benefit-button-learn-more">Learn More</button></a>
                            <a href="/gyms/partnerships"><button className="benefit-button" id="benefit-action-button">Become A Gym Partner</button></a>
                        </div>
                    </div>
                </div>
            </section >

            <section className="faqs">
                <h2>Frequently Asked Questions</h2>
                <div className="faq-item">
                    <div className="faq-question-container">
                        <button className="faq-question" onClick={() => toggleAnswer(0)}>
                            What is VERT CERT?
                        </button>
                        {openIndex === 0 ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </div>
                    {openIndex === 0 && (
                        <div className="faq-answer">
                            <p>VERT CERT is your all-in-one platform for managing indoor climbing certifications—quick, safe, and incredibly easy to use.</p>
                        </div>
                    )}
                </div>
                <div className="faq-item">
                    <div className="faq-question-container">
                        <button className="faq-question" onClick={() => toggleAnswer(1)}>
                            Is VERT CERT free?
                        </button>
                        {openIndex === 1 ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </div>
                    {openIndex === 1 && (
                        <div className="faq-answer">
                            <p>Yes, signing up and creating a profile is completely free for individuals and there is a free trial for gyms. There are paid premium versions that will become available for both individuals and gyms in the future.</p>
                        </div>
                    )}
                </div>
                <div className="faq-item">
                    <div className="faq-question-container">
                        <button className="faq-question" onClick={() => toggleAnswer(2)}>
                            How do I get certified?
                        </button>
                        {openIndex === 2 ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </div>
                    {openIndex === 2 && (
                        <div className="faq-answer">
                            <p>To get certified, sign up on VERT CERT, visit a participating gym, and take the certification test like you normally would. Upon successful completion, simply scan your VERT CERT ID at any particpating gym to bypass the approved certification.</p>
                        </div>
                    )}
                </div>
                <div className="faq-item">
                    <div className="faq-question-container">
                        <button className="faq-question" onClick={() => toggleAnswer(3)}>
                            Can I renew my certification?
                        </button>
                        {openIndex === 3 ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </div>
                    {openIndex === 3 && (
                        <div className="faq-answer">
                            <p>Yes, you’ll receive timely notifications within your account to remind you when your certification is about to expire, ensuring you have plenty of time to prepare for renewal.</p>
                        </div>
                    )}
                </div>
                <div className="faq-item">
                    <div className="faq-question-container">
                        <button className="faq-question" onClick={() => toggleAnswer(4)}>
                            How do I find participating gyms?
                        </button>
                        {openIndex === 4 ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </div>
                    {openIndex === 4 && (
                        <div className="faq-answer">
                            <p>You can easily locate participating gyms using our interactive map on the website or, with an account, search for nearby gyms and access up-to-date gym information.</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Call-to-Action Section */}
            <section className="cta">
                <h2>Start Your Climbing Journey Today</h2>
                <p>Be one of the first to experience VERT CERT—a new way to climb and get certified, all in one seamless platform.</p>
                <a href="/sign-up">
                    <button className="cta-button" id="cta-sign-up-button">Sign Up Now</button>
                </a>
            </section>
        </div >
    );
};

export default Home;